module.exports = __webpack_public_path__ + "assets/img/1_1786_big.feb6d87d.jpg";